import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { toRefs } from 'vue';
import { IonRow, IonCol, IonGrid, useIonRouter } from '@ionic/vue';

import ListCard from '@/components/List/ListCard.vue';
import LockedCard from '@/components/Common/LockedCard.vue';

import { useProgress } from '@/composables/progress';
import { IProgress } from '@/support/interfaces/ui';
import { IChapter } from '@/support/models/chapter.interface';
import { useChapterStore } from '@/stores/chapter';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChapterList',
  props: {
    chapters: null,
    courseId: null,
    unitId: null
  },
  setup(__props: any) {

const props = __props as {
  chapters: IChapter[];
  courseId: number;
  unitId: number;
}

const { isCompleted, isStarted, retryChapter } = useChapterStore();
const { readCourseletsCount } = useProgress();

const ionRouter = useIonRouter();



const { chapters, unitId, courseId } = toRefs(props);

const getProgress = (index: number): IProgress => {
  const chapter = chapters.value[index];

  if (!chapter.courselets || !isStarted(chapter.id)) {
    return {
      count: 0,
      done: 0,
    };
  }

  return {
    count: chapter.courselets?.length,
    done: readCourseletsCount(chapter),
  };
};

const isPreviousCompleted = (index: number): boolean => {
  if (index === 0) {
    return true;
  }

  return isCompleted(chapters.value[index - 1].id);
};

const onRetry = (chapter: IChapter): void => {
  retryChapter(chapter);

  ionRouter.navigate(
    `/course/${courseId.value}/unit/${unitId.value}/chapter/${chapter.id}`,
    'forward',
    'replace'
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chapters), (chapter, index) => {
        return (_openBlock(), _createBlock(_unref(IonRow), { key: index }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                (isPreviousCompleted(index))
                  ? (_openBlock(), _createBlock(ListCard, {
                      key: 0,
                      title: chapter.name,
                      subtitle: "Lorem ipsum",
                      progress: getProgress(index),
                      "router-link": `/course/${_unref(courseId)}/unit/${_unref(unitId)}/chapter/${chapter.id}`,
                      "is-completed": _unref(isCompleted)(chapter.id),
                      onRetry: ($event: any) => (onRetry(chapter))
                    }, null, 8, ["title", "progress", "router-link", "is-completed", "onRetry"]))
                  : (_openBlock(), _createBlock(LockedCard, {
                      key: 1,
                      title: chapter.name,
                      subtitle: "Complete previous chapter to unlock"
                    }, null, 8, ["title"]))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})